import { render, staticRenderFns } from "./lap_instrumen_guru.vue?vue&type=template&id=4506a56f&"
import script from "./lap_instrumen_guru.vue?vue&type=script&lang=js&"
export * from "./lap_instrumen_guru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports